import { Popup } from '@/components/Popup'
import { NEXT_PUBLIC_MAX_BOT_URL } from '@/config'
import { Icon } from '@/icons'
import { maxPopupStore } from '@/store/MaxPopup.store'
import { observer } from 'mobx-react-lite'
import { FC, useCallback } from 'react'
import { Button } from '../Button'
import styles from './MaxPopup.module.scss'

interface MaxPopupProps {}
export const MaxPopup: FC<MaxPopupProps> = observer(({}) => {
  const goToMax = useCallback(() => {
    window.open(
      `${NEXT_PUBLIC_MAX_BOT_URL}?start=${maxPopupStore.sourceSite}`,
      '_blank'
    )

    setTimeout(() => {
      maxPopupStore.hide()
    })
  }, [])

  if (!maxPopupStore.isVisible) {
    return null
  }

  return (
    <Popup onClose={maxPopupStore.hide} className={styles.popup}>
      <div className={styles.content}>
        <div className={styles.title}>{maxPopupStore.title}</div>
        {maxPopupStore.subDescription ? (
          <div className={styles.subDescription}>
            {maxPopupStore.subDescription}
          </div>
        ) : null}
        <div className={styles.description}>{maxPopupStore.description}</div>
        <Button className={styles.button} onClick={goToMax}>
          <Icon name="max" /> Перейти в бота MAX
        </Button>
      </div>
    </Popup>
  )
})
